import React from "react";
import ModalIndex from "@Modals/layout/index";

export default React.memo(function DeleteFormations({
  onClickClose,
  show,
  onDeleteClick,
  t
}) {
  return (
    <ModalIndex  
      isOpen={show}
      onClickClose={onClickClose}
      buttonOptions={{
        click: onDeleteClick,
        color: "green",
        title: t("Supprimer")
      }}
      buttonCancelOptions={{
        click: onClickClose,
        color: "outlined",
        title: t("Annuler")
      }}
    >
      <div className="arh-font-poppins arh-font-semibold arh-text-[23px] arh-text-darkColor arh-text-center">
        {t("Êtes-vous sûr de vouloir supprimer cette formation ?")}
      </div>
    </ModalIndex  >
  );
});
